<template>
  <v-row>
    <v-col cols="12">
      <Filtro/>
    </v-col>

    <v-col cols="12">
      <TableProdutoForca/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ProdutoForca',

  components: {
    Filtro: () => import("./components/Filtro"),
    TableProdutoForca: () => import("./components/TableProdutoForca")
  }
}
</script>